import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import Logo from "../../assets/images/Logo-Icon-Regular.svg";
import { Paper, Typography } from "@mui/material";
import SignUpComponent from "../../components/auth/SignUp";

const Brand = styled.img`
  margin-top: 1rem;
  width: 64px;
  height: 64px;
  margin-bottom: 32px;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function SignUp() {
  return (
    <React.Fragment>
      <Brand src={Logo} />
      <Wrapper>
        <Helmet title="Sign Up" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Create your free account
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          Full access. No credit card needed to start.
        </Typography>

        <SignUpComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default SignUp;
